import { ILocalization, ILocalizationToken } from '../../../../../../application/language/ILocalization';
import { inject } from '../../../../../../common/container/inject';
import { injectPrimitive } from '../../../../../../common/store/base/injectPrimitive';
import { IPrimitiveStore } from '../../../../../../common/store/interface/IPrimitiveStore';
import { IJoinByInvitation } from '../../../../../../service/invitationLinks/IJoinByInvitation';
import { IProjectInvitationGet } from '../../../../../../service/invitationLinks/IProjectInvitationGet';
import { IRouterService, RouterServiceToken } from '../../../../../../service/route/IRouterService';
import { UserSystemRoleModelPermissionMap } from '../../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';

import { LayoutNotificationType } from '../../../../../layout/common/notification/store/ILayoutNotification';
import { IMainLayoutDomainStore } from "../../../../../layout/main/store/domain/IMainLayoutDomainStore";
import { ConfettiManager } from "./ConfettiManager";
import { InvatationNotFoundError } from "./InvatationNotFoundError";
import { IProjectInvitationJoinDomain } from "./IProjectInvitationJoinDomain";
import { IProjectInvitationJoinUI } from "./IProjectInvitationJoinUI";

export class ProjectInvitationJoinUI implements IProjectInvitationJoinUI {
  private alreadyBootedId: IPrimitiveStore<string | null>;

  isBooting: IPrimitiveStore<boolean>;
  projectInvatation: IPrimitiveStore<IProjectInvitationGet | null>;
  isJoining: IPrimitiveStore<boolean>;
  chosenRole: IPrimitiveStore<string | null>;

  constructor(
    private layoutDomain: IMainLayoutDomainStore,
    private domainService: IProjectInvitationJoinDomain,
    private router: IRouterService = inject<IRouterService>(RouterServiceToken),
    private i18n: ILocalization = inject<ILocalization>(ILocalizationToken)
  ) {
    this.alreadyBootedId = injectPrimitive(null);
    this.isBooting = injectPrimitive(false);
    this.isJoining = injectPrimitive(false);
    this.projectInvatation = injectPrimitive(null)
    this.chosenRole = injectPrimitive(null)
  }


  boot = async (invitationId: string) => {
    if (this.alreadyBootedId.value === invitationId || this.isBooting.value) return;
    this.isBooting.setValue(true);

    try {
      const getProjectInvatation = await this.domainService.getInvitationInfo(invitationId)
      if (!getProjectInvatation) {
        throw new InvatationNotFoundError(invitationId)
      }
      if (!getProjectInvatation?.abledRoles[0].id) {
        throw new InvatationNotFoundError(invitationId)
      }
      if (getProjectInvatation.project.id) {
        this.redirectForAdmin(getProjectInvatation.project.id)
      }
      this.projectInvatation.setValue(getProjectInvatation)
      this.chosenRole.setValue(getProjectInvatation.abledRoles[0].id)
      this.alreadyBootedId.setValue(invitationId);
    } catch  {
      this.notFoundInvatation();
    } finally {
      this.isBooting.setValue(false);
    }
  }

  redirectForAdmin = (projectId:string) => {
    const isAdmin = this.layoutDomain.userHaveAnyAccess([UserSystemRoleModelPermissionMap['global-allow-any']]);
    if (isAdmin) {
      this.router.goTo(`/project/${projectId}/info`)
    }
  }
  join = async () => {
    const roleId = this.chosenRole.value;
    const invitationId = this.projectInvatation.value?.id;

    if (!roleId || !invitationId) {
      return;
    }

    this.isJoining.setValue(true);
    try {
      const payload: IJoinByInvitation = { roleId, invitationId };
      await this.domainService.joinByInvitation(payload);
      this.successJoin()
    } catch (e) {
      console.log(e)
      this.errorDuringJoining()
    }
    finally {
      this.isJoining.setValue(false);
    }
  }

 successJoin = () => {
  const manager = new ConfettiManager();
  manager.addConfetti();

  const projectId = this.projectInvatation.value?.project?.id;

  setTimeout(() => {
    if (projectId) {
      this.router.goTo(`/project/${projectId}/info`);
      return;
    }
    this.router.goTo('/project/all');
  }, 2000);
}

  errorDuringJoining = () => {
    this.sendNotification(
      LayoutNotificationType.error,
      this.i18n.translate('invitation.join.errorDuringJoining')
    );
  }
  notFoundInvatation = () => {
    this.router.goTo('/');
    this.sendNotification(
      LayoutNotificationType.info,
      this.i18n.translate('invitation.join.invitationNotFound')
    );
  }

  sendNotification = (type: LayoutNotificationType, text: string) => {
    setTimeout(() => {
      this.layoutDomain.notifications.showNotification({
        type,
        text,
      });
    }, 0);
  }
}